enum AuthRoutes {
  Login = '/auth/login',
  ResetPassword = '/auth/reset-password',
  ResetEmailSent = '/auth/reset-succeed',
  SetNewPassword = '/auth/new-password',
}

export default AuthRoutes
